import React, {useState, useContext, useEffect} from "../../_snowpack/pkg/react.js";
import {CheckCircleIcon} from "../../_snowpack/pkg/@heroicons/react/outline.js";
import {SettingsContext} from "../App.js";
import {RadioGroup} from "../../_snowpack/pkg/@headlessui/react.js";
const AmiiboType = ({value}) => {
  return /* @__PURE__ */ React.createElement(RadioGroup.Option, {
    value
  }, ({checked}) => /* @__PURE__ */ React.createElement("div", {
    className: `flex flex-row justify-between p-2 hover:cursor-pointer rounded-md ${checked ? "bg-red-500 dark:bg-gray-900 text-white font-bold" : "hover:bg-red-200 dark:hover:bg-gray-700"}`
  }, /* @__PURE__ */ React.createElement("p", {
    className: "first-letter:capitalize"
  }, value), checked && /* @__PURE__ */ React.createElement(CheckCircleIcon, {
    className: "w-6 h-6 text-white"
  })));
};
const AmiiboTypeSwitcher = () => {
  const [settings, setSettings] = useContext(SettingsContext);
  const [amiiboType, setAmiiboType] = useState(settings.amiiboType);
  useEffect(() => {
    setSettings({...settings, amiiboType});
  }, [amiiboType]);
  return /* @__PURE__ */ React.createElement(RadioGroup, {
    value: amiiboType,
    onChange: setAmiiboType,
    className: "flex flex-col gap-2 pt-2"
  }, /* @__PURE__ */ React.createElement(AmiiboType, {
    value: "figure"
  }), /* @__PURE__ */ React.createElement(AmiiboType, {
    value: "card"
  }), /* @__PURE__ */ React.createElement(AmiiboType, {
    value: "yarn"
  }));
};
export default AmiiboTypeSwitcher;
